module.exports = __webpack_public_path__ + "img/img6.b235c46a.jpg";